function createEvent(objectTarget, eventName, eventHandler, eventHandlerScope) {
	var genericHandler = function (event) {
		event = event || window.event;

		if (!event)
			return;

		event.target = event.target || event.srcElement;

		if (event.target && typeof event.target.nodeType !== 'undefined' && event.target.nodeType === 3)
			event.target = event.target.parentNode;

		if (typeof event.stopPropagation === 'undefined')
			event.stopPropagation = function() { event.cancelBubble = true; }

		if (typeof event.preventDefault === 'undefined')
			event.preventDefault = function() { event.returnValue = false; }

		if (eventHandlerScope)
			eventHandler.call(eventHandlerScope, event);
		else
			eventHandler(event);
	}

	if (typeof objectTarget === 'string') {
		var object = document.getElementById(objectTarget);
		if (object)
			createEvent(object, eventName, eventHandler, eventHandlerScope);
	}
	else if (objectTarget.addEventListener)
  		objectTarget.addEventListener(eventName,genericHandler,false);
	else if (objectTarget.attachEvent)
  	objectTarget.attachEvent('on'+eventName,genericHandler);
}

function globalSearchKeyPress(event)
{
	if (event.keyCode == 13)
	{
		globalSearchButtonClick(event);
		event.preventDefault();
	}
}

function unmapReturnKey(event)
{
	if (event.keyCode == 13)
		event.preventDefault();
}

function globalSearchButtonClick(event)
{
	var obj = document.getElementById('globalSearch');
  if ((obj) && (obj.value.length != 0))
  	location = 'search?query=' + encodeURIComponent(obj.value).replace('%2F','/').replace('%5C','\\'); //.replace("&","%26").replace("#","%23"));
  event.preventDefault();
}

function acceptCookies(event)
{
	var div = document.getElementById('cookieDiv');
	if (div)
	{
		div.style.display = 'none';
		var date = new Date();
		date.setTime(date.getTime()+(150*24*60*60*1000));
		document.cookie = "hideCookies=T; expires="+date.toGMTString();
	}
	event.preventDefault();
}

function contentPlacement(content)
{
	var more = document.getElementById('more');

	if (more)
	{
		var page = parseInt(more.getAttribute('data-page'));
		var min = parseInt(more.getAttribute('data-min'));
		var regex = new RegExp(more.getAttribute('data-regex'), "g");

		var num = content.match(regex);

		if (!num || num.length < min)
			more.parentNode.style.display = 'none';
		else
			more.setAttribute('data-page', (page + 1).toString());

		if (num)
		{
			var div = document.createElement('div');
			div.innerHTML = content;

			var placement = document.getElementById('placement');
			for (var i = 0; placement && i < div.childNodes.length; i++) {
				placement.parentNode.insertBefore(div.childNodes[i], placement);
			}
		}
	}
	FB.XFBML.parse();
	twttr.widgets.load();
	IN.parse();
}

function playVideo(event)
{
	var play = document.getElementById('play');

	if (play)
	{
		var code = play.getAttribute('data-video');
		if (code)
		{
			if (ga && typeof ga === 'function')
				ga('send', 'event', 'video', 'play', 'intro-szkolenie');
			play.parentNode.className = 'video playing';
			if (code.substr(0, 2) === 'v:') {	
				play.parentNode.innerHTML = '<iframe src="https://player.vimeo.com/video/' + code.substr(2) + '?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			} else {
				play.parentNode.innerHTML = '<iframe frameborder="0" src="//www.youtube.com/embed/' + code + '?autoplay=1"></iframe>';
			}			
		}
	}
}

function domReady()
{
	if (typeof window.scrollToForm === 'string')
		window.location.hash = window.scrollToForm;

	window.remoteRequest = new RemoteRequest();

	createEvent('form_email', 'keypress', unmapReturnKey);
	createEvent('globalSearch', 'keypress', globalSearchKeyPress);
	createEvent('globalSearchButton', 'click', globalSearchButtonClick);
	createEvent('cookieClose', 'click', acceptCookies);

	if (document.getElementById('days'))
		new BoxSwitcher('days');

	createEvent('more', 'click', function(event) {
		window.remoteRequest.requestData(window.location, parseInt(document.getElementById('more').getAttribute('data-page')) + 1, 'POSTS', contentPlacement);
		event.preventDefault();
	});

	createEvent('play', 'click', playVideo);

	if (document.querySelectorAll)
	{
		var items = document.querySelectorAll('.ad, .ad-big');
		for (var i = 0; i < items.length; i++)
		{
			var link = items[i].querySelector('a');
			var type = items[i].className.indexOf('ad-big') !== -1 ? 'blog_ad_big' : 'blog_ad_small';
			createEvent(link, 'click', function(type, event) {
				if (ga && typeof ga === 'function')
					ga('send', 'event', 'link', 'click', type);
			}.bind(window, type));
		}
	}

	createEvent('SunflowerForm', 'submit', function(event) {
		var button = document.getElementById('form_submit');
		if (button.className.indexOf('disabled') !== -1)
			event.preventDefault();
		else
			button.className = button.className + ' disabled';
	});

	$(".rozwijany a").click(function(event) {
		event.preventDefault();

		var item = $(this).parent().next();
		if (item.hasClass('current'))
			return;

		$('.opis.current').slideUp('fast').removeClass('current');
		item.slideDown('fast').addClass('current');
	});
};
